module.exports = __webpack_public_path__ + "img/titleNew.86e28d68.png";